/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mijn PiE BFF
 * OpenAPI spec version: 1.0
 */

export type Frequency = typeof Frequency[keyof typeof Frequency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Frequency = {
  OneTime: 'OneTime',
  Weekly: 'Weekly',
  Monthly: 'Monthly',
  Quarterly: 'Quarterly',
  Yearly: 'Yearly',
} as const;
